import { render, staticRenderFns } from "./BreadTabulatorViewLatest.vue?vue&type=template&id=02299b39&scoped=true&"
import script from "./BreadTabulatorViewLatest.vue?vue&type=script&lang=js&"
export * from "./BreadTabulatorViewLatest.vue?vue&type=script&lang=js&"
import style0 from "./BreadTabulatorViewLatest.vue?vue&type=style&index=0&id=02299b39&scoped=true&lang=css&"
import style1 from "./BreadTabulatorViewLatest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02299b39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VList,VListItem,VListItemTitle,VMenu,VRow,VTab,VTabs,VTextField})
